export const PRODUCT_ID_ERROR_TAG = 'PRODUCT_ID_NULL_ERROR';
export const PRODUCT_ID_ERROR_TAG_PDP = 'PRODUCT_ID_NULL_ERROR_PDP';
